module.exports = __webpack_public_path__ + "assets/img/Clipboard@2x.dfca4815.png";